/*=========================================================================================
File Name: actions.js
Description: Vuex Store - actions
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const actions = {
	
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////
	
	// Vertical NavMenu
	updateVerticalNavMenuWidth({ commit }, width) {
		commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
	},
	
	// VxAutoSuggest
	updateStarredPage({ commit }, payload) {
		commit('UPDATE_STARRED_PAGE', payload)
	},
	
	// The Navbar
	arrangeStarredPagesLimited({ commit }, list) {
		commit('ARRANGE_STARRED_PAGES_LIMITED', list)
	},
	arrangeStarredPagesMore({ commit }, list) {
		commit('ARRANGE_STARRED_PAGES_MORE', list)
	},
	
	// /////////////////////////////////////////////
	// UI
	// /////////////////////////////////////////////
	
	toggleContentOverlay({ commit }) {
		commit('TOGGLE_CONTENT_OVERLAY')
	},
	updateTheme({ commit }, val) {
		commit('UPDATE_THEME', val)
	},
	
	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////
	
	updateUserInfo({ commit }, payload) {
		commit('UPDATE_USER_INFO', payload)
	},
	
	
	// ////////////////////////////////////////////
	// CUSTOM
	// ////////////////////////////////////////////
	
	// Takedown Domains
	setTakedownDomains: ({commit}, domains) => {
		commit('setTakedownDomains', domains)
	},
	clearTakedownDomains: ({commit}) => {
		commit('clearTakedownDomains')
	},

	// Notifications
	setNotifications:({commit}, payload) => {
		commit('SET_NOTIFICATIONS', payload);
	},
	clearNotifications:({commit}) => {
		commit('CLEAR_NOTIFICATIONS');
	},

	// Roles
	setRoles:({commit}, payload) => {
		commit('SET_ROLES', payload);
	},
	clearRoles:({commit}) => {
		commit('CLEAR_ROLES');
	},

	// Permissions Master
	setPermissionsMaster:({commit}, payload) => {
		commit('SET_PERMISSIONS_MASTER', payload);
	},
	clearPermissionsMaster:({commit}) => {
		commit('CLEAR_PERMISSIONS_MASTER');
	},

	// Categories Master
	setCategoriesMaster:({commit}, payload) => {
		commit('SET_CATEGORIES_MASTER', payload);
	},
	clearCategoriesMaster:({commit}) => {
		commit('CLEAR_CATEGORIES_MASTER');
	},

	// Keywords Master
	setKeywordsMaster:({commit}, payload) => {
		commit('SET_KEYWORDS_MASTER', payload);
	},
	clearKeywordsMaster:({commit}) => {
		commit('CLEAR_KEYWORDS_MASTER');
	},

	// Prefixes Master
	setPrefixesMaster:({commit}, payload) => {
		commit('SET_PREFIXES_MASTER', payload);
	},
	clearPrefixesMaster:({commit}) => {
		commit('CLEAR_PREFIXES_MASTER');
	},

	// Suffixes Master
	setSuffixesMaster:({commit}, payload) => {
		commit('SET_SUFFIXES_MASTER', payload);
	},
	clearSuffixesMaster:({commit}) => {
		commit('CLEAR_SUFFIXES_MASTER');
	},

	// Curated Names Master
	setCuratedNamesMaster:({commit}, payload) => {
		commit('SET_CURATED_NAMES_MASTER', payload);
	},
	clearCuratedNamesMaster:({commit}) => {
		commit('CLEAR_CURATED_NAMES_MASTER');
	},

	// Curated Tags Master
	setCuratedTagsMaster:({commit}, payload) => {
		commit('SET_CURATED_TAGS_MASTER', payload);
	},
	clearCuratedTagsMaster:({commit}) => {
		commit('CLEAR_CURATED_TAGS_MASTER');
	},
}

export default actions
